var items = {
  "block.minecraft.air": "aria",
  "block.minecraft.stone": "piera",
  "block.minecraft.granite": "granito",
  "block.minecraft.polished_granite": "granito łustro",
  "block.minecraft.diorite": "diorite",
  "block.minecraft.polished_diorite": "diorite łustra",
  "block.minecraft.andesite": "andezite",
  "block.minecraft.polished_andesite": "andezite łustra",
  "block.minecraft.grass_block": "bloco de erba",
  "block.minecraft.dirt": "tera",
  "block.minecraft.coarse_dirt": "tera seca",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "neçelio crèmese",
  "block.minecraft.warped_nylium": "neçelio strùpio",
  "block.minecraft.cobblestone": "piere",
  "block.minecraft.oak_planks": "ase de ròvare",
  "block.minecraft.spruce_planks": "ase de avede",
  "block.minecraft.birch_planks": "ase de brédoła",
  "block.minecraft.jungle_planks": "ase de ła jungla",
  "block.minecraft.acacia_planks": "ase de acasia",
  "block.minecraft.dark_oak_planks": "ase de ròvare scura",
  "block.minecraft.crimson_planks": "asse crèmese",
  "block.minecraft.warped_planks": "asse strùpie",
  "block.minecraft.oak_sapling": "albareło de ròvare",
  "block.minecraft.spruce_sapling": "albareło de avede",
  "block.minecraft.birch_sapling": "albareło de brédoła",
  "block.minecraft.jungle_sapling": "albareło de ła jungla",
  "block.minecraft.acacia_sapling": "albareło de acasia",
  "block.minecraft.dark_oak_sapling": "albareło de ròvare scura",
  "block.minecraft.bedrock": "piera de'l fondo",
  "block.minecraft.sand": "sabia",
  "block.minecraft.red_sand": "sabia rosa",
  "block.minecraft.gravel": "giara",
  "block.minecraft.gold_ore": "oro grezo",
  "block.minecraft.iron_ore": "fero grezo",
  "block.minecraft.coal_ore": "carbon grezo",
  "block.minecraft.nether_gold_ore": "mineral de oro del nether",
  "block.minecraft.oak_log": "fusto de ròvare",
  "block.minecraft.spruce_log": "fusto de avede",
  "block.minecraft.birch_log": "fusto de brédoła",
  "block.minecraft.jungle_log": "fusto de ła jungla",
  "block.minecraft.acacia_log": "fusto de acasia",
  "block.minecraft.dark_oak_log": "fusto de ròvare scura",
  "block.minecraft.crimson_stem": "ganbo crèmese",
  "block.minecraft.warped_stem": "ganbo strùpio",
  "block.minecraft.stripped_oak_log": "fusto de ròvare descorsà",
  "block.minecraft.stripped_spruce_log": "fusto de avede descorsà",
  "block.minecraft.stripped_birch_log": "fusto de brédoła descorsà",
  "block.minecraft.stripped_jungle_log": "fusto de ła jungla descorsà",
  "block.minecraft.stripped_acacia_log": "fusto de acasia descorsà",
  "block.minecraft.stripped_dark_oak_log": "fusto de ròvare scura descorsà",
  "block.minecraft.stripped_crimson_stem": "ganbo crèmese descortegà",
  "block.minecraft.stripped_warped_stem": "ganbo strùpio descortegà",
  "block.minecraft.stripped_oak_wood": "lenjo de ròvare descorsà",
  "block.minecraft.stripped_spruce_wood": "łenjo de avede descorsà",
  "block.minecraft.stripped_birch_wood": "łenjo de brédoła descorsà",
  "block.minecraft.stripped_jungle_wood": "łenjo de ła jungla descorsà",
  "block.minecraft.stripped_acacia_wood": "łenjo de acasia descorsà",
  "block.minecraft.stripped_dark_oak_wood": "łenjo de ròvare scura descorsà",
  "block.minecraft.stripped_crimson_hyphae": "ife crèmese descortegàe",
  "block.minecraft.stripped_warped_hyphae": "ife strùpie descortegàe",
  "block.minecraft.oak_wood": "łenjo de ròvare",
  "block.minecraft.spruce_wood": "łenjo de avede",
  "block.minecraft.birch_wood": "łenjo de brédoła",
  "block.minecraft.jungle_wood": "łenjo de ła jungla",
  "block.minecraft.acacia_wood": "łenjo de acasia",
  "block.minecraft.dark_oak_wood": "łenjo de ròvare scura",
  "block.minecraft.crimson_hyphae": "ife crèmese",
  "block.minecraft.warped_hyphae": "ife strùpie",
  "block.minecraft.oak_leaves": "foje de ròvare",
  "block.minecraft.spruce_leaves": "foje de avede",
  "block.minecraft.birch_leaves": "foje de brédoła",
  "block.minecraft.jungle_leaves": "foje de ła jungla",
  "block.minecraft.acacia_leaves": "foje de acasia",
  "block.minecraft.dark_oak_leaves": "foje de ròvare scura",
  "block.minecraft.sponge": "sponga",
  "block.minecraft.wet_sponge": "sponga moja",
  "block.minecraft.glass": "vero",
  "block.minecraft.lapis_ore": "łapislàsułi grezi",
  "block.minecraft.lapis_block": "bloco de łapislàsułi",
  "block.minecraft.dispenser": "despensador",
  "block.minecraft.sandstone": "arenaria",
  "block.minecraft.chiseled_sandstone": "arenaria łavorà",
  "block.minecraft.cut_sandstone": "arenaria intajà",
  "block.minecraft.note_block": "bloco sonoro",
  "block.minecraft.powered_rail": "roara ałimentada",
  "block.minecraft.detector_rail": "roara rełevadora",
  "block.minecraft.sticky_piston": "piston tacaiso",
  "block.minecraft.cobweb": "tełarina",
  "block.minecraft.grass": "erba",
  "block.minecraft.fern": "felze",
  "block.minecraft.dead_bush": "rame seche",
  "block.minecraft.seagrass": "erba acuàdega",
  "block.minecraft.sea_pickle": "serùmoło de mar",
  "block.minecraft.piston": "piston",
  "block.minecraft.white_wool": "łana bianca",
  "block.minecraft.orange_wool": "łana naransa",
  "block.minecraft.magenta_wool": "łana mazenta",
  "block.minecraft.light_blue_wool": "łana sełeste",
  "block.minecraft.yellow_wool": "łana zała",
  "block.minecraft.lime_wool": "łana lime",
  "block.minecraft.pink_wool": "łana roza",
  "block.minecraft.gray_wool": "łana griza",
  "block.minecraft.light_gray_wool": "łana griza ciara",
  "block.minecraft.cyan_wool": "łana sian",
  "block.minecraft.purple_wool": "łana vioła",
  "block.minecraft.blue_wool": "łana blè",
  "block.minecraft.brown_wool": "łana maron",
  "block.minecraft.green_wool": "łana verda",
  "block.minecraft.red_wool": "łana rosa",
  "block.minecraft.black_wool": "łana negra",
  "block.minecraft.dandelion": "pisacan",
  "block.minecraft.poppy": "papàvaro",
  "block.minecraft.blue_orchid": "orchidèa blè",
  "block.minecraft.allium": "fior de ajo",
  "block.minecraft.azure_bluet": "fiori de canpo",
  "block.minecraft.red_tulip": "tułipan roso",
  "block.minecraft.orange_tulip": "tułipan naransa",
  "block.minecraft.white_tulip": "tułipan bianco",
  "block.minecraft.pink_tulip": "tułipan roza",
  "block.minecraft.oxeye_daisy": "margarita",
  "block.minecraft.cornflower": "sełestin",
  "block.minecraft.lily_of_the_valley": "łiłio",
  "block.minecraft.wither_rose": "roza de wither",
  "block.minecraft.brown_mushroom": "fongo maron",
  "block.minecraft.red_mushroom": "fongo roso",
  "block.minecraft.crimson_fungus": "fongo crèmese",
  "block.minecraft.warped_fungus": "fongo strùpio",
  "block.minecraft.crimson_roots": "raixe crèmese",
  "block.minecraft.warped_roots": "raixe strùpie",
  "block.minecraft.nether_sprouts": "buti del nether",
  "block.minecraft.weeping_vines": "ranpeganti pianzenti",
  "block.minecraft.twisting_vines": "ranpeganti intorcolài",
  "block.minecraft.sugar_cane": "cana da sùcaro",
  "block.minecraft.kelp": "àlega",
  "block.minecraft.bamboo": "canavera",
  "block.minecraft.gold_block": "bloco de oro",
  "block.minecraft.iron_block": "bloco de fero",
  "block.minecraft.oak_slab": "łiston de ròvare",
  "block.minecraft.spruce_slab": "łiston de avede",
  "block.minecraft.birch_slab": "łiston de brédoła",
  "block.minecraft.jungle_slab": "łiston de ła jungla",
  "block.minecraft.acacia_slab": "łiston de acasia",
  "block.minecraft.dark_oak_slab": "łiston de ròvare scura",
  "block.minecraft.crimson_slab": "liston crèmese",
  "block.minecraft.warped_slab": "liston strùpio",
  "block.minecraft.stone_slab": "łiston de piera",
  "block.minecraft.smooth_stone_slab": "łiston de piera łustra",
  "block.minecraft.sandstone_slab": "łiston de arenaria",
  "block.minecraft.cut_sandstone_slab": "łiston de arenaria intajà",
  "block.minecraft.petrified_oak_slab": "łiston de ròvare piedrifegà",
  "block.minecraft.cobblestone_slab": "łiston de piere",
  "block.minecraft.brick_slab": "łiston de cuarełi",
  "block.minecraft.stone_brick_slab": "łiston de cuarełi de piera",
  "block.minecraft.nether_brick_slab": "łiston de cuarełi de'l nether",
  "block.minecraft.quartz_slab": "łiston de cuarzo",
  "block.minecraft.red_sandstone_slab": "łiston de arenaria rosa",
  "block.minecraft.cut_red_sandstone_slab": "łiston de arenaria rosa intajà",
  "block.minecraft.purpur_slab": "łiston de purpur",
  "block.minecraft.prismarine_slab": "łiston de prizmarin",
  "block.minecraft.prismarine_brick_slab": "łiston de cuarełi de prizmarin",
  "block.minecraft.dark_prismarine_slab": "łiston de prizmarin scuro",
  "block.minecraft.smooth_quartz": "bloco de cuarso łustro",
  "block.minecraft.smooth_red_sandstone": "arenaria rosa łustra",
  "block.minecraft.smooth_sandstone": "arenaria łustra",
  "block.minecraft.smooth_stone": "piera łustra",
  "block.minecraft.bricks": "cuarełi",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "librarìa",
  "block.minecraft.mossy_cobblestone": "piere musciade",
  "block.minecraft.obsidian": "osidiana",
  "block.minecraft.torch": "torsa",
  "block.minecraft.end_rod": "zbara de'l end",
  "block.minecraft.chorus_plant": "pianta de chorus",
  "block.minecraft.chorus_flower": "fior de chorus",
  "block.minecraft.purpur_block": "purpur",
  "block.minecraft.purpur_pillar": "piłastro de purpur",
  "block.minecraft.purpur_stairs": "scałe de purpur",
  "block.minecraft.spawner": "zenarador",
  "block.minecraft.oak_stairs": "scałe de ròvare",
  "block.minecraft.chest": "baùl",
  "block.minecraft.diamond_ore": "diamante grezo",
  "block.minecraft.diamond_block": "bloco de diamante",
  "block.minecraft.crafting_table": "banco da łaoro",
  "block.minecraft.farmland": "tera sapada",
  "block.minecraft.furnace": "fornaze",
  "block.minecraft.ladder": "scałion",
  "block.minecraft.rail": "roara",
  "block.minecraft.cobblestone_stairs": "scałe de piera",
  "block.minecraft.lever": "łieva",
  "block.minecraft.stone_pressure_plate": "pedana a presion de piera",
  "block.minecraft.oak_pressure_plate": "pedana a presion de ròvare",
  "block.minecraft.spruce_pressure_plate": "pedana a presion de avede",
  "block.minecraft.birch_pressure_plate": "pedana a presion de brédoła",
  "block.minecraft.jungle_pressure_plate": "pedana a presion de ła jungla",
  "block.minecraft.acacia_pressure_plate": "pedana a presion de acasia",
  "block.minecraft.dark_oak_pressure_plate": "pedana a presion de ròvare scura",
  "block.minecraft.crimson_pressure_plate": "pedana a pression crèmese",
  "block.minecraft.warped_pressure_plate": "pedana a pression strùpia",
  "block.minecraft.polished_blackstone_pressure_plate": "pedana a pression de pieranegra lustra",
  "block.minecraft.redstone_ore": "redstone greza",
  "block.minecraft.redstone_torch": "torsa de redstone",
  "block.minecraft.snow": "neve",
  "block.minecraft.ice": "giaso",
  "block.minecraft.snow_block": "bloco de neve",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "crea",
  "block.minecraft.jukebox": "jukebox",
  "block.minecraft.oak_fence": "ringhiera de ròvare",
  "block.minecraft.spruce_fence": "ringhiera de avede",
  "block.minecraft.birch_fence": "ringhiera de brédoła",
  "block.minecraft.jungle_fence": "ringhiera de ła jungla",
  "block.minecraft.acacia_fence": "ringhiera de acasia",
  "block.minecraft.dark_oak_fence": "ringhiera de ròvare scura",
  "block.minecraft.crimson_fence": "ringhiera crèmese",
  "block.minecraft.warped_fence": "ringhiera strùpia",
  "block.minecraft.pumpkin": "suca",
  "block.minecraft.carved_pumpkin": "suca intajada",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "sabia de łe àneme",
  "block.minecraft.soul_soil": "tera de le àneme",
  "block.minecraft.basalt": "basalto",
  "block.minecraft.polished_basalt": "basalto lustro",
  "block.minecraft.soul_torch": "torsa de le àneme",
  "block.minecraft.glowstone": "zluzorite",
  "block.minecraft.jack_o_lantern": "łanterna de suca",
  "block.minecraft.oak_trapdoor": "rebalta de ròvare",
  "block.minecraft.spruce_trapdoor": "rebalta de avede",
  "block.minecraft.birch_trapdoor": "rebalta de brédoła",
  "block.minecraft.jungle_trapdoor": "rebalta de ła jungla",
  "block.minecraft.acacia_trapdoor": "rebalta de acasia",
  "block.minecraft.dark_oak_trapdoor": "rebalta de ròvare",
  "block.minecraft.crimson_trapdoor": "rebalta crèmese",
  "block.minecraft.warped_trapdoor": "rebalta strùpia",
  "block.minecraft.infested_stone": "piera infestada",
  "block.minecraft.infested_cobblestone": "piere infestade",
  "block.minecraft.infested_stone_bricks": "cuarełi de piera infestadi",
  "block.minecraft.infested_mossy_stone_bricks": "cuarełi de piera musciadi infestadi",
  "block.minecraft.infested_cracked_stone_bricks": "cuarełi de piera crepè infestadi",
  "block.minecraft.infested_chiseled_stone_bricks": "cuarełi de piera łavoradi infestadi",
  "block.minecraft.stone_bricks": "cuarełi de piera",
  "block.minecraft.mossy_stone_bricks": "cuarełi de piera musciadi",
  "block.minecraft.cracked_stone_bricks": "cuarełi de piera crepadi",
  "block.minecraft.chiseled_stone_bricks": "cuarełi de piera łavoradi",
  "block.minecraft.brown_mushroom_block": "bloco de fongo maron",
  "block.minecraft.red_mushroom_block": "bloco de fongo roso",
  "block.minecraft.mushroom_stem": "ganbo de fongo",
  "block.minecraft.iron_bars": "sbare de fero",
  "block.minecraft.chain": "cadena",
  "block.minecraft.glass_pane": "panel de vero",
  "block.minecraft.melon": "inguria",
  "block.minecraft.vine": "ranpeganti",
  "block.minecraft.oak_fence_gate": "sarajo de ròvare",
  "block.minecraft.spruce_fence_gate": "sarajo de avede",
  "block.minecraft.birch_fence_gate": "sarajo de brédoła",
  "block.minecraft.jungle_fence_gate": "sarajo de ła jungla",
  "block.minecraft.acacia_fence_gate": "sarajo de acasia",
  "block.minecraft.dark_oak_fence_gate": "sarajo de ròvare scura",
  "block.minecraft.crimson_fence_gate": "sarajo crèmese",
  "block.minecraft.warped_fence_gate": "sarajo strùpio",
  "block.minecraft.brick_stairs": "scałe de cuarełi",
  "block.minecraft.stone_brick_stairs": "scałe de cuarełi de piera",
  "block.minecraft.mycelium": "micełio",
  "block.minecraft.lily_pad": "tageri",
  "block.minecraft.nether_bricks": "cuarełi de'l nether",
  "block.minecraft.cracked_nether_bricks": "cuarèi del nether crepadi",
  "block.minecraft.chiseled_nether_bricks": "cuarèi del nether lavoradi",
  "block.minecraft.nether_brick_fence": "ringhiera de cuarełi de'l nether",
  "block.minecraft.nether_brick_stairs": "scałe de cuarełi de'l nether",
  "block.minecraft.enchanting_table": "banco da incantamenti",
  "block.minecraft.end_portal_frame": "tełar de'l portal de'l end",
  "block.minecraft.end_stone": "piera de'l end",
  "block.minecraft.end_stone_bricks": "cuarełi de piera de'l end",
  "block.minecraft.dragon_egg": "ovo de dragon",
  "block.minecraft.redstone_lamp": "lànpada redstone",
  "block.minecraft.sandstone_stairs": "scałe de arenaria",
  "block.minecraft.emerald_ore": "zmeraldo grezo",
  "block.minecraft.ender_chest": "baùl de ender",
  "block.minecraft.tripwire_hook": "ingancio par fiło",
  "block.minecraft.emerald_block": "bloco de zmeraldo",
  "block.minecraft.spruce_stairs": "scałe de avede",
  "block.minecraft.birch_stairs": "scałe de brédoła",
  "block.minecraft.jungle_stairs": "scałe de ła jungla",
  "block.minecraft.crimson_stairs": "scale crèmese",
  "block.minecraft.warped_stairs": "scale strùpie",
  "block.minecraft.command_block": "bloco comando",
  "block.minecraft.beacon": "faro",
  "block.minecraft.cobblestone_wall": "mureta de piere",
  "block.minecraft.mossy_cobblestone_wall": "mureta de piere musciade",
  "block.minecraft.brick_wall": "mureta de cuarełi",
  "block.minecraft.prismarine_wall": "mureta de prizmarin",
  "block.minecraft.red_sandstone_wall": "mureta de arenaria rosa",
  "block.minecraft.mossy_stone_brick_wall": "mureta de cuarełi de piera musciada",
  "block.minecraft.granite_wall": "mureta de granito",
  "block.minecraft.stone_brick_wall": "mureta de cuarełi de piera",
  "block.minecraft.nether_brick_wall": "mureta de cuarełi de'l nether",
  "block.minecraft.andesite_wall": "mureta de andezite",
  "block.minecraft.red_nether_brick_wall": "mureta de cuarełi rosi de'l nether",
  "block.minecraft.sandstone_wall": "mureta de arenaria",
  "block.minecraft.end_stone_brick_wall": "mureta de cuarełi de piera de'l end",
  "block.minecraft.diorite_wall": "mureta de diorite",
  "block.minecraft.blackstone_wall": "mureta de pieranegra",
  "block.minecraft.polished_blackstone_wall": "mureta de pieranegra lustra",
  "block.minecraft.polished_blackstone_brick_wall": "mureta de cuarèi de pieranegra lustra",
  "block.minecraft.stone_button": "boton de piera",
  "block.minecraft.oak_button": "boton de ròvare",
  "block.minecraft.spruce_button": "boton de avede",
  "block.minecraft.birch_button": "boton de brédoła",
  "block.minecraft.jungle_button": "boton de ła jungla",
  "block.minecraft.acacia_button": "boton de acasia",
  "block.minecraft.dark_oak_button": "boton de ròvare scura",
  "block.minecraft.crimson_button": "boton crèmese",
  "block.minecraft.warped_button": "boton strùpio",
  "block.minecraft.polished_blackstone_button": "boton de pieranegra lustra",
  "block.minecraft.anvil": "ancùzene",
  "block.minecraft.chipped_anvil": "ancùzene schejà",
  "block.minecraft.damaged_anvil": "ancùzene danezada",
  "block.minecraft.trapped_chest": "baùl tràpoła",
  "block.minecraft.light_weighted_pressure_plate": "pedana a pezo (pezi picenini)",
  "block.minecraft.heavy_weighted_pressure_plate": "pedana a pezo (pezi grosi)",
  "block.minecraft.daylight_detector": "sensor de łuze diurna",
  "block.minecraft.redstone_block": "bloco de redstone",
  "block.minecraft.nether_quartz_ore": "cuarso de'l nether grezo",
  "block.minecraft.hopper": "tramoza",
  "block.minecraft.chiseled_quartz_block": "bloco de cuarso łavorà",
  "block.minecraft.quartz_block": "bloco de cuarso",
  "block.minecraft.quartz_bricks": "cuarèi de cuarso",
  "block.minecraft.quartz_pillar": "piłastro de cuarso",
  "block.minecraft.quartz_stairs": "scałe de cuarso",
  "block.minecraft.activator_rail": "roara de ativasion",
  "block.minecraft.dropper": "dropador",
  "block.minecraft.white_terracotta": "teracota bianca",
  "block.minecraft.orange_terracotta": "teracota naransa",
  "block.minecraft.magenta_terracotta": "teracota mazenta",
  "block.minecraft.light_blue_terracotta": "teracota sełeste",
  "block.minecraft.yellow_terracotta": "teracota zała",
  "block.minecraft.lime_terracotta": "teracota lime",
  "block.minecraft.pink_terracotta": "teracota roza",
  "block.minecraft.gray_terracotta": "teracota griza",
  "block.minecraft.light_gray_terracotta": "teracota griza ciara",
  "block.minecraft.cyan_terracotta": "teracota sian",
  "block.minecraft.purple_terracotta": "teracota vioła",
  "block.minecraft.blue_terracotta": "teracota blè",
  "block.minecraft.brown_terracotta": "teracota maron",
  "block.minecraft.green_terracotta": "teracota verda",
  "block.minecraft.red_terracotta": "teracota rosa",
  "block.minecraft.black_terracotta": "teracota negra",
  "block.minecraft.barrier": "bariera",
  "block.minecraft.iron_trapdoor": "rebalta de fero",
  "block.minecraft.hay_block": "bała de fen",
  "block.minecraft.white_carpet": "tapé bianco",
  "block.minecraft.orange_carpet": "tapé naransa",
  "block.minecraft.magenta_carpet": "tapé mazenta",
  "block.minecraft.light_blue_carpet": "tapé sełeste",
  "block.minecraft.yellow_carpet": "tapé zało",
  "block.minecraft.lime_carpet": "tapé lime",
  "block.minecraft.pink_carpet": "tapé roza",
  "block.minecraft.gray_carpet": "tapé grizo",
  "block.minecraft.light_gray_carpet": "tapé grizo ciaro",
  "block.minecraft.cyan_carpet": "tapé sian",
  "block.minecraft.purple_carpet": "tapé vioła",
  "block.minecraft.blue_carpet": "tapé blè",
  "block.minecraft.brown_carpet": "tapé maron",
  "block.minecraft.green_carpet": "tapé verdo",
  "block.minecraft.red_carpet": "tapé roso",
  "block.minecraft.black_carpet": "tapé negro",
  "block.minecraft.terracotta": "teracota",
  "block.minecraft.coal_block": "bloco de carbon",
  "block.minecraft.packed_ice": "giaso macà",
  "block.minecraft.acacia_stairs": "scałe de acasia",
  "block.minecraft.dark_oak_stairs": "scałe de ròvare scura",
  "block.minecraft.slime_block": "bloco de zeładina",
  "block.minecraft.grass_path": "senter de erba",
  "block.minecraft.sunflower": "zirasol",
  "block.minecraft.lilac": "secomoro",
  "block.minecraft.rose_bush": "rozar",
  "block.minecraft.peony": "fołanja",
  "block.minecraft.tall_grass": "erba elta",
  "block.minecraft.large_fern": "felse granda",
  "block.minecraft.white_stained_glass": "vero bianco",
  "block.minecraft.orange_stained_glass": "vero naransa",
  "block.minecraft.magenta_stained_glass": "vero mazenta",
  "block.minecraft.light_blue_stained_glass": "vero sełeste",
  "block.minecraft.yellow_stained_glass": "vero zało",
  "block.minecraft.lime_stained_glass": "vero lime",
  "block.minecraft.pink_stained_glass": "vero roza",
  "block.minecraft.gray_stained_glass": "vero grizo",
  "block.minecraft.light_gray_stained_glass": "vero grizo ciaro",
  "block.minecraft.cyan_stained_glass": "vero sian",
  "block.minecraft.purple_stained_glass": "vero vioła",
  "block.minecraft.blue_stained_glass": "vero blè",
  "block.minecraft.brown_stained_glass": "vero maron",
  "block.minecraft.green_stained_glass": "vero verdo",
  "block.minecraft.red_stained_glass": "vero roso",
  "block.minecraft.black_stained_glass": "vero negro",
  "block.minecraft.white_stained_glass_pane": "panel de vero bianco",
  "block.minecraft.orange_stained_glass_pane": "panel de vero naransa",
  "block.minecraft.magenta_stained_glass_pane": "panel de vero mazenta",
  "block.minecraft.light_blue_stained_glass_pane": "panel de vero sełeste",
  "block.minecraft.yellow_stained_glass_pane": "panel de vero zało",
  "block.minecraft.lime_stained_glass_pane": "panel de vero lime",
  "block.minecraft.pink_stained_glass_pane": "panel de vero roza",
  "block.minecraft.gray_stained_glass_pane": "panel de vero grizo",
  "block.minecraft.light_gray_stained_glass_pane": "panel de vero grizo ciaro",
  "block.minecraft.cyan_stained_glass_pane": "panel de vero sian",
  "block.minecraft.purple_stained_glass_pane": "panel de vero vioła",
  "block.minecraft.blue_stained_glass_pane": "panel de vero blè",
  "block.minecraft.brown_stained_glass_pane": "panel de vero maron",
  "block.minecraft.green_stained_glass_pane": "panel de vero verdo",
  "block.minecraft.red_stained_glass_pane": "panel de vero roso",
  "block.minecraft.black_stained_glass_pane": "panel de vero negro",
  "block.minecraft.prismarine": "prizmarin",
  "block.minecraft.prismarine_bricks": "cuarełi de prizmarin",
  "block.minecraft.dark_prismarine": "prizmarin scuro",
  "block.minecraft.prismarine_stairs": "scałe de prizmarin",
  "block.minecraft.prismarine_brick_stairs": "scałe de cuarełi de prizmarin",
  "block.minecraft.dark_prismarine_stairs": "scałe de prizmarin scuro",
  "block.minecraft.sea_lantern": "łanterna de'l mar",
  "block.minecraft.red_sandstone": "arenaria rosa",
  "block.minecraft.chiseled_red_sandstone": "arenaria rosa łavorà",
  "block.minecraft.cut_red_sandstone": "arenaria rosa intajada",
  "block.minecraft.red_sandstone_stairs": "scałe de arenaria rosa",
  "block.minecraft.repeating_command_block": "bloco comando a repetision",
  "block.minecraft.chain_command_block": "bloco comando a cadena",
  "block.minecraft.magma_block": "bloco de magma",
  "block.minecraft.nether_wart_block": "bloco de pori de'l nether",
  "block.minecraft.warped_wart_block": "bloco de pori strùpi",
  "block.minecraft.red_nether_bricks": "cuarełi rosi de'l nether",
  "block.minecraft.bone_block": "bloco de osi",
  "block.minecraft.structure_void": "vudo de ła strutura",
  "block.minecraft.observer": "oservador",
  "block.minecraft.shulker_box": "scàtoła de shulker",
  "block.minecraft.white_shulker_box": "scàtoła de shulker bianca",
  "block.minecraft.orange_shulker_box": "scàtoła de shulker naransa",
  "block.minecraft.magenta_shulker_box": "scàtoła de shulker mazenta",
  "block.minecraft.light_blue_shulker_box": "scàtoła de shulker sełeste",
  "block.minecraft.yellow_shulker_box": "scàtoła de shulker zała",
  "block.minecraft.lime_shulker_box": "scàtoła de shulker lime",
  "block.minecraft.pink_shulker_box": "scàtoła de shulker roza",
  "block.minecraft.gray_shulker_box": "scàtoła de shulker griza",
  "block.minecraft.light_gray_shulker_box": "scàtoła de shulker griza ciara",
  "block.minecraft.cyan_shulker_box": "scàtoła de shulker sian",
  "block.minecraft.purple_shulker_box": "scàtoła de shulker vioła",
  "block.minecraft.blue_shulker_box": "scàtoła de shulker blè",
  "block.minecraft.brown_shulker_box": "scàtoła de shulker maron",
  "block.minecraft.green_shulker_box": "scàtoła de shulker verda",
  "block.minecraft.red_shulker_box": "scàtoła de shulker rosa",
  "block.minecraft.black_shulker_box": "scàtoła de shulker negra",
  "block.minecraft.white_glazed_terracotta": "teracota bianca zmaltà",
  "block.minecraft.orange_glazed_terracotta": "teracota naransa zmaltà",
  "block.minecraft.magenta_glazed_terracotta": "teracota mazenta zmaltà",
  "block.minecraft.light_blue_glazed_terracotta": "teracota sełeste zmaltà",
  "block.minecraft.yellow_glazed_terracotta": "teracota zała zmaltà",
  "block.minecraft.lime_glazed_terracotta": "teracota lime zmaltà",
  "block.minecraft.pink_glazed_terracotta": "teracota roza zmaltà",
  "block.minecraft.gray_glazed_terracotta": "teracota griza zmaltà",
  "block.minecraft.light_gray_glazed_terracotta": "teracota griza ciara zmaltà",
  "block.minecraft.cyan_glazed_terracotta": "teracota sian zmaltà",
  "block.minecraft.purple_glazed_terracotta": "teracota vioła zmaltà",
  "block.minecraft.blue_glazed_terracotta": "teracota blè zmaltà",
  "block.minecraft.brown_glazed_terracotta": "teracota maron zmaltà",
  "block.minecraft.green_glazed_terracotta": "teracota verda zmaltà",
  "block.minecraft.red_glazed_terracotta": "teracota rosa zmaltà",
  "block.minecraft.black_glazed_terracotta": "teracota negra zmaltà",
  "block.minecraft.white_concrete": "beton bianco",
  "block.minecraft.orange_concrete": "beton naransa",
  "block.minecraft.magenta_concrete": "beton mazenta",
  "block.minecraft.light_blue_concrete": "beton sełeste",
  "block.minecraft.yellow_concrete": "beton zało",
  "block.minecraft.lime_concrete": "beton lime",
  "block.minecraft.pink_concrete": "beton roza",
  "block.minecraft.gray_concrete": "beton grizo",
  "block.minecraft.light_gray_concrete": "beton grizo ciaro",
  "block.minecraft.cyan_concrete": "beton sian",
  "block.minecraft.purple_concrete": "beton vioła",
  "block.minecraft.blue_concrete": "beton blè",
  "block.minecraft.brown_concrete": "beton maron",
  "block.minecraft.green_concrete": "beton verdo",
  "block.minecraft.red_concrete": "beton roso",
  "block.minecraft.black_concrete": "beton negro",
  "block.minecraft.white_concrete_powder": "pólvar de beton bianca",
  "block.minecraft.orange_concrete_powder": "pólvar de beton naransa",
  "block.minecraft.magenta_concrete_powder": "pólvar de beton mazenta",
  "block.minecraft.light_blue_concrete_powder": "pólvar de beton sełeste",
  "block.minecraft.yellow_concrete_powder": "pólvar de beton zała",
  "block.minecraft.lime_concrete_powder": "pólvar de beton lime",
  "block.minecraft.pink_concrete_powder": "pólvar de beton roza",
  "block.minecraft.gray_concrete_powder": "pólvar de beton griza",
  "block.minecraft.light_gray_concrete_powder": "pólvar de beton griza ciara",
  "block.minecraft.cyan_concrete_powder": "pólvar de beton sian",
  "block.minecraft.purple_concrete_powder": "pólvar de beton vioła",
  "block.minecraft.blue_concrete_powder": "pólvar de beton blè",
  "block.minecraft.brown_concrete_powder": "pólvar de beton maron",
  "block.minecraft.green_concrete_powder": "pólvar de beton verda",
  "block.minecraft.red_concrete_powder": "pólvar de beton rosa",
  "block.minecraft.black_concrete_powder": "pólvar de beton negra",
  "block.minecraft.turtle_egg": "ovo de tartaruga",
  "block.minecraft.dead_tube_coral_block": "bloco de coral a tubo morto",
  "block.minecraft.dead_brain_coral_block": "bloco de coral a sarvel morto",
  "block.minecraft.dead_bubble_coral_block": "bloco de coral a bołe morto",
  "block.minecraft.dead_fire_coral_block": "bloco de coral de fogo morto",
  "block.minecraft.dead_horn_coral_block": "bloco de coral a corni morto",
  "block.minecraft.tube_coral_block": "bloco de coral a tubo",
  "block.minecraft.brain_coral_block": "bloco de coral a sarvel",
  "block.minecraft.bubble_coral_block": "bloco de coral a bołe",
  "block.minecraft.fire_coral_block": "bloco de coral de fogo",
  "block.minecraft.horn_coral_block": "bloco de coral a corni",
  "block.minecraft.tube_coral": "coral a tubo",
  "block.minecraft.brain_coral": "coral a sarvel",
  "block.minecraft.bubble_coral": "coral a bołe",
  "block.minecraft.fire_coral": "coral de fogo",
  "block.minecraft.horn_coral": "coral a corni",
  "block.minecraft.dead_brain_coral": "coral a sarvel morto",
  "block.minecraft.dead_bubble_coral": "coral a bołe morto",
  "block.minecraft.dead_fire_coral": "coral de fogo morto",
  "block.minecraft.dead_horn_coral": "coral a corno morto",
  "block.minecraft.dead_tube_coral": "coral a tubo morto",
  "block.minecraft.tube_coral_fan": "gorgonia a tubo",
  "block.minecraft.brain_coral_fan": "gorgonia a sarvel",
  "block.minecraft.bubble_coral_fan": "gorgonia a bołe",
  "block.minecraft.fire_coral_fan": "gorgonia de fogo",
  "block.minecraft.horn_coral_fan": "gorgonia a corni",
  "block.minecraft.dead_tube_coral_fan": "gorgonia a tubo morta",
  "block.minecraft.dead_brain_coral_fan": "gorgonia a sarvel morta",
  "block.minecraft.dead_bubble_coral_fan": "gorgonia a bołe morta",
  "block.minecraft.dead_fire_coral_fan": "gorgonia de fogo morta",
  "block.minecraft.dead_horn_coral_fan": "gorgonia a corni morta",
  "block.minecraft.blue_ice": "giaso blè",
  "block.minecraft.conduit": "conduto",
  "block.minecraft.polished_granite_stairs": "scałe de granito łustro",
  "block.minecraft.smooth_red_sandstone_stairs": "scałe de arenaria rosa łustra",
  "block.minecraft.mossy_stone_brick_stairs": "scałe de cuarełi de piera musciadi",
  "block.minecraft.polished_diorite_stairs": "scałe de diorite łustra",
  "block.minecraft.mossy_cobblestone_stairs": "scałe de piera musciada",
  "block.minecraft.end_stone_brick_stairs": "scałe de cuarełi de piera de'l end",
  "block.minecraft.stone_stairs": "scałe de piera",
  "block.minecraft.smooth_sandstone_stairs": "scałe de arenaria łustra",
  "block.minecraft.smooth_quartz_stairs": "scałe de cuarso łustro",
  "block.minecraft.granite_stairs": "scałe de granito",
  "block.minecraft.andesite_stairs": "scałe de andezite",
  "block.minecraft.red_nether_brick_stairs": "scałe de cuarełi rosi de'l nether",
  "block.minecraft.polished_andesite_stairs": "scałe de andezite łustra",
  "block.minecraft.diorite_stairs": "scałe de diorite",
  "block.minecraft.polished_granite_slab": "łiston de granito łustro",
  "block.minecraft.smooth_red_sandstone_slab": "łiston de arenaria rosa łustra",
  "block.minecraft.mossy_stone_brick_slab": "łiston de cuarełi de piera musciadi",
  "block.minecraft.polished_diorite_slab": "łiston de diorite łustra",
  "block.minecraft.mossy_cobblestone_slab": "łiston de piere musciade",
  "block.minecraft.end_stone_brick_slab": "łiston de cuarełi de piera de'l end",
  "block.minecraft.smooth_sandstone_slab": "łiston de arenaria łustra",
  "block.minecraft.smooth_quartz_slab": "łiston de cuarso łustro",
  "block.minecraft.granite_slab": "łiston de granito",
  "block.minecraft.andesite_slab": "łiston de andezite",
  "block.minecraft.red_nether_brick_slab": "łiston de cuarełi rosi de'l nether",
  "block.minecraft.polished_andesite_slab": "łiston de andezite łustra",
  "block.minecraft.diorite_slab": "łiston de diorite",
  "block.minecraft.scaffolding": "inpalcadura",
  "block.minecraft.iron_door": "porta de fero",
  "block.minecraft.oak_door": "porta de ròvare",
  "block.minecraft.spruce_door": "porta de avede",
  "block.minecraft.birch_door": "porta de brédoła",
  "block.minecraft.jungle_door": "porta de ła jungla",
  "block.minecraft.acacia_door": "porta de acasia",
  "block.minecraft.dark_oak_door": "porta de ròvare scura",
  "block.minecraft.crimson_door": "porta crèmese",
  "block.minecraft.warped_door": "porta strùpia",
  "block.minecraft.repeater": "repetidor de redstone",
  "block.minecraft.comparator": "conparador de redstone",
  "block.minecraft.structure_block": "bloco strutura",
  "block.minecraft.jigsaw": "bloco de architeto",
  "item.minecraft.turtle_helmet": "zgusa de tartaruga□□in te ła suca:□+2 armadura",
  "item.minecraft.scute": "scuto",
  "item.minecraft.iron_shovel": "baìl de fero□□in te ła man bòna:□+3.5 dani de ataco□-3 zveltesa de ataco",
  "item.minecraft.iron_pickaxe": "picon de fero□□in te ła man bòna:□+3 dani de ataco□-2.8 zveltesa de ataco",
  "item.minecraft.iron_axe": "manara de fero□□in te ła man bòna:□+8 dani de ataco□-3.1 zveltesa de ataco",
  "item.minecraft.flint_and_steel": "batifogo",
  "item.minecraft.apple": "pomo",
  "item.minecraft.bow": "arco",
  "item.minecraft.arrow": "fresa",
  "item.minecraft.coal": "carbon",
  "item.minecraft.charcoal": "carboneła",
  "item.minecraft.diamond": "diamante",
  "item.minecraft.iron_ingot": "łingoto de fero",
  "item.minecraft.gold_ingot": "łingoto de oro",
  "item.minecraft.netherite_ingot": "lingoto de netherite",
  "item.minecraft.netherite_scrap": "sgresenda de netherite",
  "item.minecraft.iron_sword": "spada de fero□□in te ła man bòna:□+5 dani de ataco□-2.4 zveltesa de ataco",
  "item.minecraft.wooden_sword": "spada de łenjo□□in te ła man bòna:□+3 dani de ataco□-2.4 zveltesa de ataco",
  "item.minecraft.wooden_shovel": "baìl de łenjo□□in te ła man bòna:□+1.5 dani de ataco□-3 zveltesa de ataco",
  "item.minecraft.wooden_pickaxe": "picon de łenjo□□in te ła man bòna:□+1 dani de ataco□-2.8 zveltesa de ataco",
  "item.minecraft.wooden_axe": "manara de łenjo□□in te ła man bòna:□+6 dani de ataco□-3.2 zveltesa de ataco",
  "item.minecraft.stone_sword": "spada de piera□□in te ła man bòna:□+4 dani de ataco□-2.4 zveltesa de ataco",
  "item.minecraft.stone_shovel": "baìl de piera□□in te ła man bòna:□+2.5 dani de ataco□-3 zveltesa de ataco",
  "item.minecraft.stone_pickaxe": "picon de piera□□in te ła man bòna:□+2 dani de ataco□-2.8 zveltesa de ataco",
  "item.minecraft.stone_axe": "manara de piera□□in te ła man bòna:□+8 dani de ataco□-3.2 zveltesa de ataco",
  "item.minecraft.diamond_sword": "spada de diamante□□in te ła man bòna:□+6 dani de ataco□-2.4 zveltesa de ataco",
  "item.minecraft.diamond_shovel": "baìl de diamante□□in te ła man bòna:□+4.5 dani de ataco□-3 zveltesa de ataco",
  "item.minecraft.diamond_pickaxe": "picon de diamante□□in te ła man bòna:□+4 dani de ataco□-2.8 zveltesa de ataco",
  "item.minecraft.diamond_axe": "manara de diamante□□in te ła man bòna:□+8 dani de ataco□-3 zveltesa de ataco",
  "item.minecraft.stick": "baston",
  "item.minecraft.bowl": "scudeła",
  "item.minecraft.mushroom_stew": "supa de fongi",
  "item.minecraft.golden_sword": "spada de oro□□in te ła man bòna:□+3 dani de ataco□-2.4 zveltesa de ataco",
  "item.minecraft.golden_shovel": "baìl de oro□□in te ła man bòna:□+1.5 dani de ataco□-3 zveltesa de ataco",
  "item.minecraft.golden_pickaxe": "picon de oro□□in te ła man bòna:□+1 dani de ataco□-2.8 zveltesa de ataco",
  "item.minecraft.golden_axe": "manara de oro□□in te ła man bòna:□+6 dani de ataco□-3 zveltesa de ataco",
  "item.minecraft.netherite_sword": "spada de netherite□□in te ła man bòna:□+7 dani de ataco□-2.4 zveltesa de ataco",
  "item.minecraft.netherite_shovel": "baìl de netherite□□in te ła man bòna:□+5.5 dani de ataco□-3 zveltesa de ataco",
  "item.minecraft.netherite_pickaxe": "picon de netherite□□in te ła man bòna:□+5 dani de ataco□-2.8 zveltesa de ataco",
  "item.minecraft.netherite_axe": "manara de netherite□□in te ła man bòna:□+9 dani de ataco□-3 zveltesa de ataco",
  "item.minecraft.string": "soga",
  "item.minecraft.feather": "pena",
  "item.minecraft.gunpowder": "pólvar da zbaro",
  "item.minecraft.wooden_hoe": "sapa de łenjo□□in te ła man bòna:□-3 zveltesa de ataco",
  "item.minecraft.stone_hoe": "sapa de piera□□in te ła man bòna:□-2 zveltesa de ataco",
  "item.minecraft.iron_hoe": "sapa de fero□□in te ła man bòna:□-1 zveltesa de ataco",
  "item.minecraft.diamond_hoe": "sapa de diamante□□in te ła man bòna:",
  "item.minecraft.golden_hoe": "sapa de oro□□in te ła man bòna:□-3 zveltesa de ataco",
  "item.minecraft.netherite_hoe": "sapa de netherite□□in te ła man bòna:",
  "item.minecraft.wheat_seeds": "somensa de formento",
  "item.minecraft.wheat": "formento",
  "item.minecraft.bread": "pan",
  "item.minecraft.leather_helmet": "scufia de corame□□in te ła suca:□+1 armadura",
  "item.minecraft.leather_chestplate": "tùnega de corame□□sol peto:□+3 armadura",
  "item.minecraft.leather_leggings": "braghe de corame□□su łe ganbe:□+2 armadura",
  "item.minecraft.leather_boots": "stivałi de corame□□so i piè:□+1 armadura",
  "item.minecraft.chainmail_helmet": "cełada de maja□□in te ła suca:□+2 armadura",
  "item.minecraft.chainmail_chestplate": "corasa de maja□□sol peto:□+5 armadura",
  "item.minecraft.chainmail_leggings": "braghe de maja□□su łe ganbe:□+4 armadura",
  "item.minecraft.chainmail_boots": "stivałi de maja□□so i piè:□+1 armadura",
  "item.minecraft.iron_helmet": "cełada de fero□□in te ła suca:□+2 armadura",
  "item.minecraft.iron_chestplate": "corasa de fero□□sol peto:□+6 armadura",
  "item.minecraft.iron_leggings": "braghe de fero□□su łe ganbe:□+5 armadura",
  "item.minecraft.iron_boots": "stivałi de fero□□so i piè:□+2 armadura",
  "item.minecraft.diamond_helmet": "cełada de diamante□□in te ła suca:□+3 armadura□+2 duresa de l'armadura",
  "item.minecraft.diamond_chestplate": "corasa de diamante□□sol peto:□+8 armadura□+2 duresa de l'armadura",
  "item.minecraft.diamond_leggings": "braghe de diamante□□su łe ganbe:□+6 armadura□+2 duresa de l'armadura",
  "item.minecraft.diamond_boots": "stivałi de diamante□□so i piè:□+3 armadura□+2 duresa de l'armadura",
  "item.minecraft.golden_helmet": "cełada de oro□□in te ła suca:□+2 armadura",
  "item.minecraft.golden_chestplate": "corasa de oro□□sol peto:□+5 armadura",
  "item.minecraft.golden_leggings": "braghe de oro□□su łe ganbe:□+3 armadura",
  "item.minecraft.golden_boots": "stivałi de oro□□so i piè:□+1 armadura",
  "item.minecraft.netherite_helmet": "çelada de netherite□□in te ła suca:□+3 armadura□+3 duresa de l'armadura□+1 rezistensa a'l rebàtar",
  "item.minecraft.netherite_chestplate": "corassa de netherite□□sol peto:□+8 armadura□+3 duresa de l'armadura□+1 rezistensa a'l rebàtar",
  "item.minecraft.netherite_leggings": "braghe de netherite□□su łe ganbe:□+6 armadura□+3 duresa de l'armadura□+1 rezistensa a'l rebàtar",
  "item.minecraft.netherite_boots": "stivài de netherite□□so i piè:□+3 armadura□+3 duresa de l'armadura□+1 rezistensa a'l rebàtar",
  "item.minecraft.flint": "séłeze",
  "item.minecraft.porkchop": "brizoła de porsel crùa",
  "item.minecraft.cooked_porkchop": "brizoła de porsel cozesta",
  "item.minecraft.painting": "cuadro",
  "item.minecraft.golden_apple": "pomo indorà",
  "item.minecraft.enchanted_golden_apple": "pomo indorà incantà",
  "block.minecraft.oak_sign": "cartel de ròvare",
  "block.minecraft.spruce_sign": "cartel de avede",
  "block.minecraft.birch_sign": "cartel de brédoła",
  "block.minecraft.jungle_sign": "cartel de ła jungla",
  "block.minecraft.acacia_sign": "cartel de acasia",
  "block.minecraft.dark_oak_sign": "cartel de ròvare scura",
  "block.minecraft.crimson_sign": "cartelo crèmese",
  "block.minecraft.warped_sign": "cartelo strùpio",
  "item.minecraft.bucket": "secio",
  "item.minecraft.water_bucket": "secio de àcua",
  "item.minecraft.lava_bucket": "secio de lava",
  "item.minecraft.minecart": "carel da minera",
  "item.minecraft.saddle": "seła",
  "item.minecraft.redstone": "pólvar de redstone",
  "item.minecraft.snowball": "bałoco",
  "item.minecraft.oak_boat": "barca de ròvare",
  "item.minecraft.leather": "corame",
  "item.minecraft.milk_bucket": "secio de łate",
  "item.minecraft.pufferfish_bucket": "secio con pese bała",
  "item.minecraft.salmon_bucket": "secio con salmon",
  "item.minecraft.cod_bucket": "secio con merluso",
  "item.minecraft.tropical_fish_bucket": "secio con pese tropical",
  "item.minecraft.brick": "cuarel",
  "item.minecraft.clay_ball": "bala de crea",
  "block.minecraft.dried_kelp_block": "bloco de àlega seca",
  "item.minecraft.paper": "fojo",
  "item.minecraft.book": "łibro",
  "item.minecraft.slime_ball": "bała de zeładina",
  "item.minecraft.chest_minecart": "carel co' baùl",
  "item.minecraft.furnace_minecart": "carel co' fornaze",
  "item.minecraft.egg": "ovo",
  "item.minecraft.compass": "bùsoła",
  "item.minecraft.fishing_rod": "cana da pesca",
  "item.minecraft.clock": "rełojo",
  "item.minecraft.glowstone_dust": "pólvar de zluzorite",
  "item.minecraft.cod": "merluso crùo",
  "item.minecraft.salmon": "salmon crùo",
  "item.minecraft.tropical_fish": "pese tropigal",
  "item.minecraft.pufferfish": "pese bała",
  "item.minecraft.cooked_cod": "merluso cozesto",
  "item.minecraft.cooked_salmon": "salmon cozesto",
  "item.minecraft.ink_sac": "saca de inciostro",
  "item.minecraft.red_dye": "cołorante roso",
  "item.minecraft.green_dye": "cołorante verdo",
  "item.minecraft.cocoa_beans": "fave de cacào",
  "item.minecraft.lapis_lazuli": "łapislàsułi",
  "item.minecraft.purple_dye": "cołorante vioła",
  "item.minecraft.cyan_dye": "cołorante sian",
  "item.minecraft.light_gray_dye": "cołorante grizo ciaro",
  "item.minecraft.gray_dye": "cołorante grizo",
  "item.minecraft.pink_dye": "cołorante roza",
  "item.minecraft.lime_dye": "cołorante lime",
  "item.minecraft.yellow_dye": "cołorante zało",
  "item.minecraft.light_blue_dye": "cołorante sełeste",
  "item.minecraft.magenta_dye": "cołorante mazenta",
  "item.minecraft.orange_dye": "cołorante naransa",
  "item.minecraft.bone_meal": "farina de osi",
  "item.minecraft.blue_dye": "cołorante blè",
  "item.minecraft.brown_dye": "cołorante maron",
  "item.minecraft.black_dye": "cołorante negro",
  "item.minecraft.white_dye": "cołorante bianco",
  "item.minecraft.bone": "oso",
  "item.minecraft.sugar": "sùcaro",
  "block.minecraft.cake": "torta",
  "block.minecraft.white_bed": "łeto bianco",
  "block.minecraft.orange_bed": "łeto naransa",
  "block.minecraft.magenta_bed": "łeto mazenta",
  "block.minecraft.light_blue_bed": "łeto sełeste",
  "block.minecraft.yellow_bed": "łeto zało",
  "block.minecraft.lime_bed": "łeto lime",
  "block.minecraft.pink_bed": "łeto roza",
  "block.minecraft.gray_bed": "leto griso",
  "block.minecraft.light_gray_bed": "łeto grizo ciaro",
  "block.minecraft.cyan_bed": "łeto sian",
  "block.minecraft.purple_bed": "łeto vioła",
  "block.minecraft.blue_bed": "łeto blè",
  "block.minecraft.brown_bed": "łeto maron",
  "block.minecraft.green_bed": "łeto verdo",
  "block.minecraft.red_bed": "łeto roso",
  "block.minecraft.black_bed": "łeto negro",
  "item.minecraft.cookie": "biscoto",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "fòrbeze",
  "item.minecraft.melon_slice": "feta de inguria",
  "item.minecraft.dried_kelp": "àlega seca",
  "item.minecraft.pumpkin_seeds": "somensa de suca",
  "item.minecraft.melon_seeds": "somensa de inguria",
  "item.minecraft.beef": "manzo crùo",
  "item.minecraft.cooked_beef": "bisteca",
  "item.minecraft.chicken": "połastro crùo",
  "item.minecraft.cooked_chicken": "połastro cozesto",
  "item.minecraft.rotten_flesh": "carne zmarsa",
  "item.minecraft.ender_pearl": "perla de ender",
  "item.minecraft.blaze_rod": "verga de blaze",
  "item.minecraft.ghast_tear": "łàgrema de ghast",
  "item.minecraft.gold_nugget": "pepita de oro",
  "item.minecraft.nether_wart": "poro de'l nether",
  "item.minecraft.potion": "posion mìa fabricàbiłe□nisun efeto",
  "item.minecraft.glass_bottle": "anpoła de vero",
  "item.minecraft.spider_eye": "ocio de ranjo",
  "item.minecraft.fermented_spider_eye": "ocio de ranjo farmentà",
  "item.minecraft.blaze_powder": "pólvar de blaze",
  "item.minecraft.magma_cream": "crema de magma",
  "block.minecraft.brewing_stand": "łanbico",
  "block.minecraft.cauldron": "calderon",
  "item.minecraft.ender_eye": "ocio de ender",
  "item.minecraft.glistering_melon_slice": "feta de inguria zluzegante",
  "item.minecraft.bat_spawn_egg": "ovo zenerador de barbastreło",
  "item.minecraft.bee_spawn_egg": "ovo zenerador de ava",
  "item.minecraft.blaze_spawn_egg": "ovo zenerador de blaze",
  "item.minecraft.cat_spawn_egg": "ovo zenerador de gato",
  "item.minecraft.cave_spider_spawn_egg": "ovo zenerador de ragno de le grote",
  "item.minecraft.chicken_spawn_egg": "ovo zenerador de polastro",
  "item.minecraft.cod_spawn_egg": "ovo zenerador de merlusso",
  "item.minecraft.cow_spawn_egg": "ovo zenerador de vaca",
  "item.minecraft.creeper_spawn_egg": "ovo zenerador de creeper",
  "item.minecraft.dolphin_spawn_egg": "ovo zenerador de dolfin",
  "item.minecraft.donkey_spawn_egg": "ovo zenerador de àseno",
  "item.minecraft.drowned_spawn_egg": "ovo zenerador de negà",
  "item.minecraft.elder_guardian_spawn_egg": "ovo zenerador de guardian antigo",
  "item.minecraft.enderman_spawn_egg": "ovo zenerador de enderman",
  "item.minecraft.endermite_spawn_egg": "ovo zenerador de endermite",
  "item.minecraft.evoker_spawn_egg": "ovo zenerador de evocador",
  "item.minecraft.fox_spawn_egg": "ovo zenerador de volpe",
  "item.minecraft.ghast_spawn_egg": "ovo zenerador de ghast",
  "item.minecraft.guardian_spawn_egg": "ovo zenerador de guardian",
  "item.minecraft.hoglin_spawn_egg": "ovo zenarador de hoglin",
  "item.minecraft.horse_spawn_egg": "ovo zenerador de caval",
  "item.minecraft.husk_spawn_egg": "ovo zenerador de zonbi seco",
  "item.minecraft.llama_spawn_egg": "ovo zenerador de lama",
  "item.minecraft.magma_cube_spawn_egg": "ovo zenerador de cubo de magma",
  "item.minecraft.mooshroom_spawn_egg": "ovo zenerador de mooshroom",
  "item.minecraft.mule_spawn_egg": "ovo zenerador de mulo",
  "item.minecraft.ocelot_spawn_egg": "ovo zenerador de gatopardo",
  "item.minecraft.panda_spawn_egg": "ovo zenerador de panda",
  "item.minecraft.parrot_spawn_egg": "ovo zenerador de papagal",
  "item.minecraft.phantom_spawn_egg": "ovo zenerador de phantom",
  "item.minecraft.pig_spawn_egg": "ovo zenerador de porsel",
  "item.minecraft.piglin_spawn_egg": "ovo zenarador de piglin",
  "item.minecraft.pillager_spawn_egg": "ovo zenerador de sachejador",
  "item.minecraft.polar_bear_spawn_egg": "ovo zenerador de orso polar",
  "item.minecraft.pufferfish_spawn_egg": "ovo zenerador de pesse bala",
  "item.minecraft.rabbit_spawn_egg": "ovo zenerador de conejo",
  "item.minecraft.ravager_spawn_egg": "ovo zenarador de devastador",
  "item.minecraft.salmon_spawn_egg": "ovo zenerador de salmon",
  "item.minecraft.sheep_spawn_egg": "ovo zenerador de pégora",
  "item.minecraft.shulker_spawn_egg": "ovo zenerador de shulker",
  "item.minecraft.silverfish_spawn_egg": "ovo zenerador de pesse arzentà",
  "item.minecraft.skeleton_spawn_egg": "ovo zenerador de schèletro",
  "item.minecraft.skeleton_horse_spawn_egg": "ovo zenerador de caval schèletro",
  "item.minecraft.slime_spawn_egg": "ovo zenerador de zeladina",
  "item.minecraft.spider_spawn_egg": "ovo zenerador de ragno",
  "item.minecraft.squid_spawn_egg": "ovo zenerador de calamaro",
  "item.minecraft.stray_spawn_egg": "ovo zenerador de viandante",
  "item.minecraft.strider_spawn_egg": "ovo zenarador de caminador",
  "item.minecraft.trader_llama_spawn_egg": "ovo zenerador de lama del marcante",
  "item.minecraft.tropical_fish_spawn_egg": "ovo zenerador de pesse tropigal",
  "item.minecraft.turtle_spawn_egg": "ovo zenerador de tartaruga",
  "item.minecraft.vex_spawn_egg": "ovo zenerador de vex",
  "item.minecraft.villager_spawn_egg": "ovo zenerador de paesan",
  "item.minecraft.vindicator_spawn_egg": "ovo zenarador de vendegador",
  "item.minecraft.wandering_trader_spawn_egg": "ovo zenarador de marcante anbułante",
  "item.minecraft.witch_spawn_egg": "ovo zenarador de strìa",
  "item.minecraft.wither_skeleton_spawn_egg": "ovo zenarador de schèłetro wither",
  "item.minecraft.wolf_spawn_egg": "ovo zenarador de łovo",
  "item.minecraft.zoglin_spawn_egg": "ovo zenarador de zoglin",
  "item.minecraft.zombie_spawn_egg": "ovo zenarador de zonbi",
  "item.minecraft.zombie_horse_spawn_egg": "ovo zenarador de caval zonbi",
  "item.minecraft.zombie_villager_spawn_egg": "ovo zenerador de paesan zonbi",
  "item.minecraft.zombified_piglin_spawn_egg": "ovo zenarador de piglin zonbifegà",
  "item.minecraft.experience_bottle": "anpoła de espariensa",
  "item.minecraft.fire_charge": "carga de fogo",
  "item.minecraft.writable_book": "łibro e pena",
  "item.minecraft.written_book": "łibro scrivesto",
  "item.minecraft.emerald": "smeraldo",
  "item.minecraft.item_frame": "corniza",
  "block.minecraft.flower_pot": "vazo da fiori",
  "item.minecraft.carrot": "carota",
  "item.minecraft.potato": "patata",
  "item.minecraft.baked_potato": "patata a'l forno",
  "item.minecraft.poisonous_potato": "patata vełenoza",
  "item.minecraft.map": "mapa voda",
  "item.minecraft.golden_carrot": "carota indorada",
  "block.minecraft.skeleton_skull": "tescio de schèłetro",
  "block.minecraft.wither_skeleton_skull": "tescio de schèłetro wither",
  "block.minecraft.player_head": "testa de zugador",
  "block.minecraft.zombie_head": "testa de zonbi",
  "block.minecraft.creeper_head": "testa de creeper",
  "block.minecraft.dragon_head": "testa de dragon",
  "item.minecraft.carrot_on_a_stick": "carota su baston",
  "item.minecraft.warped_fungus_on_a_stick": "fongo strùpio su bachéto",
  "item.minecraft.nether_star": "steła de'l nether",
  "item.minecraft.pumpkin_pie": "torta de suca",
  "item.minecraft.firework_rocket": "rocheta pirotècnega",
  "item.minecraft.firework_star": "steła pirotècnega",
  "item.minecraft.enchanted_book": "łibro incantà",
  "item.minecraft.nether_brick": "cuarel de'l nether",
  "item.minecraft.quartz": "cuarso de'l nether",
  "item.minecraft.tnt_minecart": "carel co' tnt",
  "item.minecraft.hopper_minecart": "carel co' tramoza",
  "item.minecraft.prismarine_shard": "scheja de prizmarin",
  "item.minecraft.prismarine_crystals": "cristal de prizmarin",
  "item.minecraft.rabbit": "conejo crùo",
  "item.minecraft.cooked_rabbit": "conejo cozesto",
  "item.minecraft.rabbit_stew": "pastisada de conejo",
  "item.minecraft.rabbit_foot": "sata de conejo",
  "item.minecraft.rabbit_hide": "pel de conejo",
  "item.minecraft.armor_stand": "suporto par armadura",
  "item.minecraft.iron_horse_armor": "bardadura de fero",
  "item.minecraft.golden_horse_armor": "bardadura de oro",
  "item.minecraft.diamond_horse_armor": "bardadura de diamante",
  "item.minecraft.leather_horse_armor": "bardadura de corame",
  "item.minecraft.lead": "zguinsajo",
  "item.minecraft.name_tag": "tabel",
  "item.minecraft.command_block_minecart": "carel co' bloco comando",
  "item.minecraft.mutton": "carne de piégora crùa",
  "item.minecraft.cooked_mutton": "carne de piégora cozesta",
  "block.minecraft.white_banner": "gonfałon bianco",
  "block.minecraft.orange_banner": "gonfałon naransa",
  "block.minecraft.magenta_banner": "gonfałon mazenta",
  "block.minecraft.light_blue_banner": "gonfałon sełeste",
  "block.minecraft.yellow_banner": "gonfałon zało",
  "block.minecraft.lime_banner": "gonfałon lime",
  "block.minecraft.pink_banner": "gonfałon roza",
  "block.minecraft.gray_banner": "gonfałon grizo",
  "block.minecraft.light_gray_banner": "gonfałon grizo ciaro",
  "block.minecraft.cyan_banner": "gonfałon sian",
  "block.minecraft.purple_banner": "gonfałon vioła",
  "block.minecraft.blue_banner": "gonfałon blè",
  "block.minecraft.brown_banner": "gonfałon maron",
  "block.minecraft.green_banner": "gonfałon verdo",
  "block.minecraft.red_banner": "gonfałon roso",
  "block.minecraft.black_banner": "gonfałon negro",
  "item.minecraft.end_crystal": "cristal de'l end",
  "item.minecraft.chorus_fruit": "fruto de chorus",
  "item.minecraft.popped_chorus_fruit": "fruto de chorus sciopà",
  "item.minecraft.beetroot": "rava",
  "item.minecraft.beetroot_seeds": "somensa de rava",
  "item.minecraft.beetroot_soup": "supa de rava",
  "item.minecraft.dragon_breath": "supio de dragon",
  "item.minecraft.splash_potion": "posion da tiro mìa fabricàbiłe□nisun efeto",
  "item.minecraft.spectral_arrow": "fresa spetral",
  "item.minecraft.tipped_arrow": "fresa inbevùa mìa fabricàbiłe□nisun efeto",
  "item.minecraft.lingering_potion": "posion parsistente mìa fabricàbiłe□nisun efeto",
  "item.minecraft.shield": "scudo",
  "item.minecraft.elytra": "elytre",
  "item.minecraft.spruce_boat": "barca de avede",
  "item.minecraft.birch_boat": "barca de brédoła",
  "item.minecraft.jungle_boat": "barca de ła jungla",
  "item.minecraft.acacia_boat": "barca de acasia",
  "item.minecraft.dark_oak_boat": "barca de ròvare scura",
  "item.minecraft.totem_of_undying": "totem de l'inmortalidà",
  "item.minecraft.shulker_shell": "zgusa de shulker",
  "item.minecraft.iron_nugget": "pepita de fero",
  "item.minecraft.knowledge_book": "łibro de ła conosensa",
  "item.minecraft.debug_stick": "baston de debug",
  "item.minecraft.music_disc_13": "disco muzegal□c418 - 13",
  "item.minecraft.music_disc_cat": "disco muzegal□c418 - cat",
  "item.minecraft.music_disc_blocks": "disco muzegal□c418 - blocks",
  "item.minecraft.music_disc_chirp": "disco muzegal□c418 - chirp",
  "item.minecraft.music_disc_far": "disco muzegal□c418 - far",
  "item.minecraft.music_disc_mall": "disco muzegal□c418 - mall",
  "item.minecraft.music_disc_mellohi": "disco muzegal□c418 - mellohi",
  "item.minecraft.music_disc_stal": "disco muzegal□c418 - stal",
  "item.minecraft.music_disc_strad": "disco muzegal□c418 - strad",
  "item.minecraft.music_disc_ward": "disco muzegal□c418 - ward",
  "item.minecraft.music_disc_11": "disco muzegal□c418 - 11",
  "item.minecraft.music_disc_wait": "disco muzegal□c418 - wait",
  "item.minecraft.music_disc_pigstep": "disco muzegal□lena raine - pigstep",
  "item.minecraft.trident": "forca□□in te ła man bòna:□+8 dani de ataco□-2.9 zveltesa de ataco",
  "item.minecraft.phantom_membrane": "menbrana de'l phantom",
  "item.minecraft.nautilus_shell": "zgusa de nautilus",
  "item.minecraft.heart_of_the_sea": "cor de'l mar",
  "item.minecraft.crossbow": "bałestra",
  "item.minecraft.suspicious_stew": "supa sospeta",
  "block.minecraft.loom": "tełar",
  "item.minecraft.flower_banner_pattern": "fegura par gonfałon□stanpa de fior",
  "item.minecraft.creeper_banner_pattern": "fegura par gonfałon□stanpa de creeper",
  "item.minecraft.skull_banner_pattern": "fegura par gonfałon□stanpa de tescio",
  "item.minecraft.mojang_banner_pattern": "fegura par gonfałon□łogo",
  "item.minecraft.globe_banner_pattern": "figura par gonfałon□globo",
  "item.minecraft.piglin_banner_pattern": "fegura par gonfałon□grugno",
  "block.minecraft.composter": "conpostador",
  "block.minecraft.barrel": "bóta",
  "block.minecraft.smoker": "fumegador",
  "block.minecraft.blast_furnace": "gran fornaze",
  "block.minecraft.cartography_table": "banco de'l cartògrafo",
  "block.minecraft.fletching_table": "banco de l'arser",
  "block.minecraft.grindstone": "moła",
  "block.minecraft.lectern": "letorin",
  "block.minecraft.smithing_table": "banco de'l ferar",
  "block.minecraft.stonecutter": "tajapiere",
  "block.minecraft.bell": "canpana",
  "block.minecraft.lantern": "łume",
  "block.minecraft.soul_lantern": "canfìn de le àneme",
  "item.minecraft.sweet_berries": "pomełe dolse",
  "block.minecraft.campfire": "fogo da canpo",
  "block.minecraft.soul_campfire": "fogo da canpo de le àneme",
  "block.minecraft.shroomlight": "sluxifongo",
  "item.minecraft.honeycomb": "caraza",
  "block.minecraft.bee_nest": "avearo",
  "block.minecraft.beehive": "avearo artifisial",
  "item.minecraft.honey_bottle": "anpoła de mel",
  "block.minecraft.honey_block": "bloco de mel",
  "block.minecraft.honeycomb_block": "bloco de caraze",
  "block.minecraft.lodestone": "magnetite",
  "block.minecraft.netherite_block": "bloco de netherite",
  "block.minecraft.ancient_debris": "ruinassi antighi",
  "block.minecraft.target": "bersajo",
  "block.minecraft.crying_obsidian": "osidiana pianzente",
  "block.minecraft.blackstone": "pieranegra",
  "block.minecraft.blackstone_slab": "liston de pieranegra",
  "block.minecraft.blackstone_stairs": "scale de pieranegra",
  "block.minecraft.gilded_blackstone": "pieranegra indorada",
  "block.minecraft.polished_blackstone": "pieranegra lustra",
  "block.minecraft.polished_blackstone_slab": "liston de pieranegra lustra",
  "block.minecraft.polished_blackstone_stairs": "scale de pieranegra lustra",
  "block.minecraft.chiseled_polished_blackstone": "pieranegra lustra lavorada",
  "block.minecraft.polished_blackstone_bricks": "cuarèi de pieranegra lustra",
  "block.minecraft.polished_blackstone_brick_slab": "liston de cuarèi de pieranegra lustra",
  "block.minecraft.polished_blackstone_brick_stairs": "scale de cuarèi de pieranegra lustra",
  "block.minecraft.cracked_polished_blackstone_bricks": "cuarèi de pieranegra lustra crepadi",
  "block.minecraft.respawn_anchor": "àncora de respawn",
}
export const vec_it = items; 
